"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVEN_COMPONENT_TO_RUNBOOK_LINK = exports.AvenComponent = void 0;
/**
 * Warning! New AvenComponents require configuration across Sentry & PagerDuty, check with Mathew/Usman
 * before adding new ones
 */
/** @TranslateToPython @TranslateToRust */
var AvenComponent;
(function (AvenComponent) {
    AvenComponent["underwriting"] = "underwriting";
    AvenComponent["cardholder"] = "cardholder";
    AvenComponent["notary"] = "notary";
    AvenComponent["advisor"] = "advisor";
    AvenComponent["crypto"] = "crypto";
    AvenComponent["auto"] = "auto";
    AvenComponent["mlo"] = "mlo";
    AvenComponent["communications"] = "communications";
    AvenComponent["compliance"] = "compliance";
    AvenComponent["servicing"] = "servicing";
    AvenComponent["notaryTeam"] = "notaryTeam";
    AvenComponent["origination"] = "origination";
    AvenComponent["fraud"] = "fraud";
    AvenComponent["legalDocs"] = "legalDocs";
    AvenComponent["primaryOnCall"] = "primaryOnCall";
    AvenComponent["opsCommunications"] = "opsCommunications";
    AvenComponent["infra"] = "infra";
    AvenComponent["mortgage"] = "mortgage";
    AvenComponent["deposit"] = "deposit";
    AvenComponent["aiAgent"] = "ai-agent";
    AvenComponent["merchantPortal"] = "merchantPortal";
    AvenComponent["partnership"] = "partnership";
    AvenComponent["partnershipSupport"] = "partnershipSupport";
})(AvenComponent || (exports.AvenComponent = AvenComponent = {}));
// On-call runbook per component. Single source of truth for both aven_backend (logFatal/NonFatal...)
// and aven_python (the pager loggers), so the two stay in sync. 'NA' where no runbook exists yet.
/** @TranslateToPython */
exports.AVEN_COMPONENT_TO_RUNBOOK_LINK = {
    [AvenComponent.underwriting]: 'https://docs.google.com/document/d/1vMjq091g0_VugE-Ulx1RSTW03tf98-GZHkihpPXZ6zI/edit',
    [AvenComponent.cardholder]: 'https://docs.google.com/document/d/1qWHaiBmFWyf2b7N2GO6UbOPQI1YqKm89tRxJiDu7L7g/edit',
    [AvenComponent.notary]: 'https://docs.google.com/document/d/1JSaP-JGhVXifPdfSkUzXC97Odd_8nzNPR7p2hjf_XCQ/edit',
    [AvenComponent.advisor]: 'https://docs.google.com/document/d/1FrSueeZ7Mmx6ClrUmzeG2pLtxJbBYeFVGNO60IMFAko/edit?usp=sharing',
    [AvenComponent.crypto]: 'NA',
    [AvenComponent.auto]: 'https://docs.google.com/document/d/1e-50M0fgDbLXtwTtZyt8gc0E6I6eju2CYnKycoZkWig/edit?usp=sharing',
    [AvenComponent.mlo]: 'https://docs.google.com/document/d/1ent_pYmL7iWpg_6broBBQIlv80uV0_3ZZGSJD4LEzI0/edit?usp=sharing',
    [AvenComponent.communications]: 'https://docs.google.com/document/d/1afCp1RR1sjU1AnCnIQ8Ds3DJyqXR0iaCAUDSOqCBW1s/edit?usp=sharing',
    [AvenComponent.compliance]: 'https://docs.google.com/document/d/18B8kINhHK-6_jkYYA0jgj5wjey-sx1xsocfe7gMWBCM/edit?usp=sharing',
    [AvenComponent.servicing]: 'https://docs.google.com/document/d/1f5O_wCAK5G5fnkidT6w_zgGxXj2CHFY4Yvzx_JtWIEs/edit?usp=sharing',
    [AvenComponent.notaryTeam]: 'NA',
    [AvenComponent.origination]: 'https://docs.google.com/document/d/1SJaBEpHE6Mz4AuywSQzY8U2Y0kVy2zBAYlFEMbNaZVQ/edit?usp=sharing',
    [AvenComponent.fraud]: 'https://docs.google.com/document/d/1XgtLvYsAQHIcnycrFoGRuSjV95iqbOsYIg_X7rF0mf4/edit?usp=sharing',
    [AvenComponent.legalDocs]: 'https://docs.google.com/document/d/1ffL-6nMZ7fxT9-HwAz93eTx8K_o4oUjFbb4nd3uIUTY/edit?usp=sharing',
    [AvenComponent.primaryOnCall]: 'https://docs.google.com/document/d/11o2kUYYkk9eTVObVrR0C1CJ71ZE2-R86wG74ahbpA1U/edit?usp=sharing',
    [AvenComponent.opsCommunications]: 'https://docs.google.com/document/d/1tNfwv1uaMK-nRnRi4tiHgPSc4M1IsoSdwaT6_lqF1vA/edit?usp=sharing',
    [AvenComponent.infra]: 'https://docs.google.com/document/d/1FpsBBTOXd33zfN9p9qvgwgzuGhXjbQNcOqUThPQD6Io/edit?usp=sharing',
    [AvenComponent.mortgage]: 'https://docs.google.com/document/d/1hbq0iEU0DLRaS98jwTeny9ElYMgHW-NAAGO0khk_VX0/edit?usp=sharing',
    [AvenComponent.deposit]: 'https://docs.google.com/document/d/1AbVWieU-iCA0Zfvx-B4vHkIabnJSBn1n9ZtEbYozX1o/edit?tab=t.0#heading=h.id9aypu1dosc',
    [AvenComponent.aiAgent]: 'https://docs.google.com/document/d/1CPFz2nvHdbG4pWIDuEsijw50TyWsEvjaKH_z1CQJck0/edit?tab=t.0',
    [AvenComponent.merchantPortal]: 'NA',
    [AvenComponent.partnership]: 'https://docs.google.com/document/d/1bg0xdfYU9KTEx6mr23VMl0LrS99Rpqqv_ef5Xulo6_Q/edit?tab=t.0',
    [AvenComponent.partnershipSupport]: 'https://docs.google.com/document/d/1UeBNkM5U71wsjDNx7rZ5CLdsht_4pWu83_nwxAATETc/edit?tab=t.0',
};
